import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @module Utils
 */

/**
 * toQuery
 *
 * Shallow copies object while omitting undefined attributes
 */
export var toStringMap = function toStringMap(optional) {
  if (optional === undefined) return {};
  return Object.keys(optional).reduce(function (result, key) {
    var value = optional[key];
    var reduce = reduceStringMap(value);
    if (reduce.length > 0) result[key] = reduce;
    return result;
  }, {});
};

var isString = function isString(i) {
  return typeof i === "string";
};

var isArray = function isArray(i) {
  return Array.isArray(i);
};

var reduceStringMap = function reduceStringMap(value) {
  var result = [];

  if (isArray(value)) {
    value.forEach(function (val) {
      if (isNumber(val)) result.push(val.toString());
      if (isString(val)) result.push(val);
    });
    return result.join(",");
  }

  if (isNumber(value)) return value.toString();
  if (isString(value)) return value;
  return "";
};

var isNumber = function isNumber(n) {
  return typeof n === "number";
};
/**
 * toTimeout
 *
 * Returns timeout value from request object. Delegates to default client
 * timeout if not specified
 */


export var toTimeout = function toTimeout(_ref, client) {
  var timeout = _ref.timeout;
  if (isNumber(timeout)) return timeout;
  return client.config.timeout;
};
/**
 * toHeader
 *
 * Extracts HTTP Header object from request and client default headers
 *
 * Precendence is given to request specific headers
 */

export var toHeader = function toHeader(_ref2, client) {
  var _ref2$header = _ref2.header,
      header = _ref2$header === void 0 ? {} : _ref2$header;
  return _objectSpread(_objectSpread({}, client.config.header), toStringMap(header));
};
/**
 * toAuthHeader
 *
 * Extracts credentials into authorization header format
 */

export var toAuthHeader = function toAuthHeader(client, options) {
  var credentials = [];
  var api_key = options.api_key || client.config.api_key;
  credentials.push(["api_key", api_key]);
  var licensee = options.licensee;
  if (licensee !== undefined) credentials.push(["licensee", licensee]);
  var user_token = options.user_token;
  if (user_token !== undefined) credentials.push(["user_token", user_token]);
  return "IDEALPOSTCODES ".concat(toCredentialString(credentials));
};
/**
 * appendAuthorization
 *
 * Mutates a headers object to include Authorization header. Will insert if found:
 * - api_key
 * - licensee
 * - user_token
 */

export var appendAuthorization = function appendAuthorization(_ref3) {
  var header = _ref3.header,
      options = _ref3.options,
      client = _ref3.client;
  header.Authorization = toAuthHeader(client, options);
  return header;
};

var toCredentialString = function toCredentialString(credentials) {
  return credentials.map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        key = _ref5[0],
        value = _ref5[1];

    return "".concat(key, "=\"").concat(value, "\"");
  }).join(" ");
}; // Adds source IP to headers


export var appendIp = function appendIp(_ref6) {
  var header = _ref6.header,
      options = _ref6.options;
  var sourceIp = options.sourceIp;
  if (sourceIp !== undefined) header["IDPC-Source-IP"] = sourceIp;
  return header;
}; // Adds filters to query

export var appendFilter = function appendFilter(_ref7) {
  var query = _ref7.query,
      options = _ref7.options;
  var filter = options.filter;
  if (filter !== undefined) query.filter = filter.join(",");
  return query;
}; // Adds tags to query

export var appendTags = function appendTags(_ref8) {
  var client = _ref8.client,
      query = _ref8.query,
      options = _ref8.options;
  var tags;
  if (client.config.tags.length) tags = client.config.tags;
  if (options.tags) tags = options.tags;
  if (tags !== undefined) query.tags = tags.join(",");
  return query;
}; // Adds pagination attributes to query

export var appendPage = function appendPage(_ref9) {
  var query = _ref9.query,
      options = _ref9.options;
  var page = options.page,
      limit = options.limit;
  if (page !== undefined) query.page = page.toString();
  if (limit !== undefined) query.limit = limit.toString();
  return query;
};